<template>
    <b-modal :title='modalTitle' id='sop_modal'>
        <b-form>
            <b-form-group>
                <label for="">Title</label>
                <b-form-textarea v-model="formData.name" placeholder="Enter SOP title" rows="3" class="mb-3"></b-form-textarea>
            </b-form-group>
            <b-form-group v-if="must_hide_editor_toggle == false">
                <label style="width: 100%;" for="">SOP Editor Type</label>
                <div class="btn-group">
                    <b-button size="sm" :variant="formData.builder_enabled ? 'primary' : 'outline-dark'" @click="formData.builder_enabled = true">
                        Builder Mode
                    </b-button>
                    <b-button size="sm" :variant="!formData.builder_enabled ? 'primary' : 'outline-dark'" @click="formData.builder_enabled = false">
                        PDF Uploader Mode
                    </b-button>
                </div>
            </b-form-group>
        </b-form>
        
        <template #modal-footer>
            <b-button :disabled="is_saving" @click="cancel">Cancel</b-button>
            <b-button :disabled="is_saving" @click="save" variant="success">Save</b-button>
        </template>
        <b-overlay :show="is_saving" no-wrap></b-overlay>
    </b-modal>

</template>

<script>
import { sopState, sopMethods} from '@/state/helpers.js'
export default {
    props:{
        formPayload:{},
    },
    data:() => ({
        formData:{
            id: -1,
            name: '',
            builder_enabled: true,
        },
        modalTitle: '',

        is_saving: false,
    }),
    computed:{
        ...sopState,
        must_hide_editor_toggle(){
            return this.$store.getters['clientAdmin/userType'] == 'admin' || this.$store.getters['clientAdmin/userType'] == 'client';
        }
    },
    methods:{
        ...sopMethods,
        cancel(){
            this.$bvModal.hide('sop_modal');
        },
        save(){
            let params = {
                id: this.formData.id,
                name: this.formData.name,
                builder_enabled: this.formData.builder_enabled,
            }
            // set correct group param name for different roles
            switch(this.$store.getters['clientAdmin/userType']){
                case 'admin':{
                    params['sop_group_id'] = this.selected_sop_group;
                    break;
                }
                case 'client_admin':{
                    params['client_group_id'] = this.selected_sop_group;
                    break;
                }
            }

            // Remove 'builder_enabled' param for ccb admin payload
            if(this.must_hide_editor_toggle){
                delete params.builder_enabled;
            }

            // save with api
            this.is_saving = true;
            this.saveSopType(params)
                .then((response)=>{
                    this.loadSops(this.selected_sop_group)
                    .then(()=>{
                        // if new sop, insert default revision. pass in params and response id
                        this.handleAfterSave(params, response.id);
                    })
            })
        },

        handleAfterSave(params, response_id){
            if(this.must_hide_editor_toggle){
                //* handle for ccb admin - new doc needs first revision inserted.
                if(params.id == -1){
                    this.$emit('insertFirstRevision', response_id);
                }
            }
            else{
                //* client admin
                if(params.id == -1 && params.builder_enabled){
                    this.$emit('insertFirstRevision', response_id);
                }
            }
            //* finish saving chain
            this.is_saving = false;
            this.$nextTick(()=>{
                this.cancel();
            })
        }
},
    mounted(){
        if(this.formPayload != null){//* EXISTING ITEM
            this.modalTitle = `Edit ${this.formPayload.name}`;

            this.formData.id = this.formPayload.id;
            this.formData.name = this.formPayload.name;
            this.formData.group_id = this.formPayload.group_id;
            this.formData.builder_enabled = this.formPayload.builder_enabled;
        }
        else{//* NEW ITEM
            this.modalTitle = `Create New SOP`;
        }
    },
}
</script>

<style>

</style>